import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { isArray } from 'lodash';
import { api } from '.';
import { TEMPORARY_COVER_STATUTORY_LIMIT_KEY } from '../constants/temp';
import { CoverageAmountEnum } from '../shared/generated';
/**
 * Contract
 */

export var apiGetContract = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(contractId, token) {
    var res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (contractId) {
              _context.next = 3;
              break;
            }

            throw new Error("Invalid contract id: ".concat(contractId));

          case 3:
            _context.next = 5;
            return api.get("/contracts/".concat(contractId), {
              params: {
                token: token
              }
            });

          case 5:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch contract: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function apiGetContract(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var apiUpdateContract = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload, token) {
    var id, args, res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            id = payload.id, args = _objectWithoutProperties(payload, _excluded);

            if (id) {
              _context2.next = 4;
              break;
            }

            throw new Error("Invalid contract id: ".concat(id));

          case 4:
            _context2.next = 6;
            return api.patch("/contracts/".concat(id), args, {
              params: {
                token: token
              }
            });

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to update contract: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function apiUpdateContract(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Contract requirements
 */

export var apiGetContractRequirements = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(contractId, token, extraParams) {
    var _res$data, res, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (contractId) {
              _context3.next = 3;
              break;
            }

            throw new Error("Invalid contract id: ".concat(contractId));

          case 3:
            _context3.next = 5;
            return api.get('/contract_requirements', {
              params: _objectSpread({
                contract_id: contractId,
                sort_column: 'created_at',
                sort_order: 'DESC',
                token: token
              }, extraParams)
            });

          case 5:
            res = _context3.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data)) {
              res.data.data = res.data.data.map(function (item) {
                var _item$contract_requir, _item$contract_requir2, _item$contract_requir3, _item$contract_requir4;

                if (((_item$contract_requir = item.contract_requirement) === null || _item$contract_requir === void 0 ? void 0 : (_item$contract_requir2 = _item$contract_requir.data) === null || _item$contract_requir2 === void 0 ? void 0 : _item$contract_requir2['coverage_amount_type']) === CoverageAmountEnum.STATUTORY_LIMIT && !((_item$contract_requir3 = item.contract_requirement) !== null && _item$contract_requir3 !== void 0 && (_item$contract_requir4 = _item$contract_requir3.data) !== null && _item$contract_requir4 !== void 0 && _item$contract_requir4['amount'])) {
                  item.contract_requirement.data = _objectSpread(_objectSpread({}, item.contract_requirement.data), {}, {
                    amount: TEMPORARY_COVER_STATUTORY_LIMIT_KEY
                  });
                }

                return item;
              });
            }

            return _context3.abrupt("return", [res.data.data]);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            message = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg;
            console.error("Failed to fetch contract requirements: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 10]]);
  }));

  return function apiGetContractRequirements(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiCreateContractRequirement = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload, token) {
    var res, _err$response4, _err$response4$data, _err$response4$data$d, _err$response4$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.post("/contract_requirements", payload, {
              params: {
                token: token
              }
            });

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data.data.contract_requirement]);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            message = (_err$response4 = _context4.t0.response) === null || _err$response4 === void 0 ? void 0 : (_err$response4$data = _err$response4.data) === null || _err$response4$data === void 0 ? void 0 : (_err$response4$data$d = _err$response4$data.detail) === null || _err$response4$data$d === void 0 ? void 0 : (_err$response4$data$d2 = _err$response4$data$d[0]) === null || _err$response4$data$d2 === void 0 ? void 0 : _err$response4$data$d2.msg;
            console.error("Failed to create contract requirement: ".concat(message));
            return _context4.abrupt("return", [null, _context4.t0]);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiCreateContractRequirement(_x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiUpdateContractRequirement = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(contractRequirementId, payload, token) {
    var res, _err$response5, _err$response5$data, _err$response5$data$d, _err$response5$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            if (contractRequirementId) {
              _context5.next = 3;
              break;
            }

            throw new Error('No contract requirement id was provided');

          case 3:
            _context5.next = 5;
            return api.patch("/contract_requirements/".concat(contractRequirementId), payload, {
              params: {
                token: token
              }
            });

          case 5:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data.data.contract_requirement]);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            message = (_err$response5 = _context5.t0.response) === null || _err$response5 === void 0 ? void 0 : (_err$response5$data = _err$response5.data) === null || _err$response5$data === void 0 ? void 0 : (_err$response5$data$d = _err$response5$data.detail) === null || _err$response5$data$d === void 0 ? void 0 : (_err$response5$data$d2 = _err$response5$data$d[0]) === null || _err$response5$data$d2 === void 0 ? void 0 : _err$response5$data$d2.msg;
            console.error("Failed to update contract requirement ".concat(contractRequirementId, " : ").concat(message));
            return _context5.abrupt("return", [null, _context5.t0]);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));

  return function apiUpdateContractRequirement(_x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiDeleteContractRequirement = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(contractRequirementId, token) {
    var res, _err$response6, _err$response6$data, _err$response6$data$d, _err$response6$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;

            if (contractRequirementId) {
              _context6.next = 3;
              break;
            }

            throw new Error('No contract requirement id was provided');

          case 3:
            _context6.next = 5;
            return api["delete"]("/contract_requirements/".concat(contractRequirementId), {
              params: {
                token: token
              }
            });

          case 5:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data.data.contract_requirement]);

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](0);
            message = (_err$response6 = _context6.t0.response) === null || _err$response6 === void 0 ? void 0 : (_err$response6$data = _err$response6.data) === null || _err$response6$data === void 0 ? void 0 : (_err$response6$data$d = _err$response6$data.detail) === null || _err$response6$data$d === void 0 ? void 0 : (_err$response6$data$d2 = _err$response6$data$d[0]) === null || _err$response6$data$d2 === void 0 ? void 0 : _err$response6$data$d2.msg;
            console.error("Failed to delete contract requirement ".concat(contractRequirementId, " : ").concat(message));
            return _context6.abrupt("return", [null, _context6.t0]);

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 9]]);
  }));

  return function apiDeleteContractRequirement(_x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();